export default {
  title: 'Debt Collection',
  subtitle: 'Overdue invoice management and escalation',
  pipeline: {
    title: 'Pipeline',
    notice_1: 'Notice 1',
    notice_2: 'Notice 2',
    final_notice: 'Final Notice',
    legal: 'Legal',
    resolved: 'Resolved',
    notice_1_sub: '30+ days overdue',
    notice_2_sub: '60+ days overdue',
    final_notice_sub: '90+ days overdue',
    legal_sub: 'Manual escalation',
  },
  fields: {
    invoice: 'Invoice',
    customer: 'Customer',
    unit: 'Unit',
    property: 'Property',
    amount_due: 'Amount Due',
    days_overdue: 'Days Overdue',
    stage: 'Stage',
    created_at: 'Case Opened',
    escalated_at: 'Last Escalated',
    notice_sent_at: 'Notice Sent',
    resolved_at: 'Resolved',
  },
  stages: {
    notice_1: 'Notice 1',
    notice_2: 'Notice 2',
    final_notice: 'Final Notice',
    legal: 'Legal',
    resolved: 'Resolved',
  },
  detail: {
    page_title: 'Case {{invoice_number}}',
    unit_label: 'Unit {{unit}}',
  },
  actions: {
    escalate: 'Escalate',
    resolve: 'Resolve',
    add_note: 'Add Note',
    mark_notice_sent: 'Mark Notice Sent Today',
    generate_legal_notice: 'Generate Legal Notice',
    view_invoice: 'View Invoice',
  },
  escalate_modal: {
    title: 'Escalate Case',
    current_stage: 'Current Stage',
    target_stage: 'Escalate to',
    confirm: 'Escalate',
    to_legal: 'Escalate to Legal',
    to_resolved: 'Mark Resolved',
  },
  resolve_confirm:
    'Mark this case as resolved? The invoice remains unpaid until a payment is recorded.',
  notes: {
    title: 'Notes Log',
    placeholder: 'Add note...',
    added_by: 'by {{user}}',
    notice_sent_log: 'Notice sent date updated',
    empty: 'No notes yet',
  },
  timeline: {
    title: 'Escalation Timeline',
    case_created: 'Case created',
    auto_escalated: 'Auto-escalated to {{stage}}',
    manually_escalated: 'Manually escalated to {{stage}}',
    resolved: 'Case resolved',
    upcoming: 'Next: {{stage}}, auto on {{date}}',
  },
  empty: {
    title: 'No overdue cases',
    description: 'Cases are created automatically when invoices are 30 days past due',
  },
  errors: {
    cannot_escalate_resolved: 'Resolved cases cannot be escalated',
    cannot_move_backward: 'Cases can only move forward in stage',
    note_required: 'Note text cannot be empty',
  },
  invoice_details: {
    title: 'Invoice Details',
    due: 'Due',
    amount: 'Amount',
    paid: 'Paid',
    balance: 'Balance',
  },
  case_summary: {
    title: 'Case Summary',
    days_overdue: 'Days Overdue',
    notice_sent: 'Notice Sent',
    not_sent: '—',
  },
  legal_notice_toast: 'Legal notice PDF generation coming soon',
}
